import FileUploadFieldWrapper from '@/modules/fields/components/FileUploadWrapper';
import { mount as mountDarkmode } from '@/common/darkmode.js';
import { registerAutosaveCommentListeners } from '@/lib/autosaver-comment';
import { mountVueComponent, mountVueWithComponents } from '@/lib/mount-vue-component';

export default function () {
	mountDarkmode();

	import('@/modules/users/components/UserFields').then((userFields) => {
		mountVueComponent('user-fields', userFields);
	});

	import('@/modules/documents/components/DocumentsList').then((documentsList) => {
		mountVueComponent('documents-list', documentsList);
	});

	// helpIcon
	import('@/lib/components/Shared/HelpIcon.vue').then((helpIcon) => {
		mountVueComponent('help-icon', helpIcon);
	});

	import('@/lib/components/Fields/validator/Validator').then((validator) => {
		mountVueWithComponents('validator', validator, { FileUploadFieldWrapper });
	});

	import('@/lib/components/Comments/Comments.vue').then((comments) => {
		mountVueComponent('comments', comments);
	});

	import('@/modules/entries/components/EntriesList.vue').then((entriesList) => {
		mountVueComponent('entries-list', entriesList);
	});

	import('@/modules/grants/components/GrantList').then((grantList) => {
		mountVueComponent('grants-list', grantList);
	});

	import('@/lib/components/Shared/AgreementModal.vue').then((agreementModal) => {
		mountVueComponent('agreement-modal', agreementModal);
	});

	import('@/modules/users/components/Agreement.vue').then((agreement) => {
		mountVueComponent('agreement', agreement);
	});

	registerAutosaveCommentListeners();
}
